import React from 'react';
import { IonIcon } from '@ionic/react';
import { lockClosedOutline, documentTextOutline } from 'ionicons/icons';
import { Link } from 'react-router-dom';

type Props = {
  hasUploadedAllDocs: boolean;
};

const PendingApprovalCard: React.FC<Props> = ({ hasUploadedAllDocs }) => {
  return (
    <div className="p-4 sm:p-6 min-h-56 h-full bg-background dark:bg-background-accent border border-border rounded-lg overflow-hidden">
      <h2 className="text-lg font-semibold text-text-dark-high dark:text-text-light-high mb-4">
        My Wallet
      </h2>
      <div className="space-y-4 p-4 bg-customs-lavender-foreground dark:bg-background-accent border border-secondary rounded-lg">
        <div className="flex items-center gap-4">
          <div className="px-3 py-2 rounded-full border-4 border-warning/20">
            <IonIcon icon={lockClosedOutline} className="size-8 text-warning" />
          </div>
          <div>
            <h6 className="font-semibold high-emphasis-text leading-none">
              Wallet setup locked
            </h6>
            <small className="medium-emphasis-text">
              {hasUploadedAllDocs
                ? 'Your documents are under review.'
                : 'Finish uploading your business documents to begin review.'}
            </small>
          </div>
        </div>

        <div className="flex gap-2 items-start p-4 bg-black/5 dark:bg-white/5 rounded-xl">
          <IonIcon
            icon={documentTextOutline}
            className="size-6 text-primary mt-0.5"
          />
          <div>
            <h5 className="font-medium text-sm high-emphasis-text">
              {hasUploadedAllDocs
                ? "We're reviewing your documents"
                : 'Complete your business verification first'}
            </h5>
            <p className="text-xs medium-emphasis-text mt-1">
              {hasUploadedAllDocs
                ? 'Wallet setup unlocks automatically once every business document has been approved by our team. You will be notified as soon as approval is complete.'
                : 'All required business documents must be uploaded and approved before you can create a wallet. Head to Getting Started to finish uploading.'}
            </p>
          </div>
        </div>

        {!hasUploadedAllDocs && (
          <Link
            to="/dashboard/get-started/"
            className="w-full flex items-center justify-center gap-2.5 py-3 bg-primary text-white rounded-xl text-sm font-semibold hover:opacity-90 transition shadow-md shadow-primary/20"
          >
            <IonIcon icon={documentTextOutline} className="size-4" />
            <span>Go to Business Verification</span>
          </Link>
        )}
      </div>
    </div>
  );
};

export default PendingApprovalCard;
